import React, { useEffect } from "react";
import {
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { Errors, Field } from "../../../../Interface/scheduler/form";
import { useFormContext } from "../../../contexts/FormContext";
import { useErrorClassClassifier } from "../../../hooks/useErrorClassClassifier";
import { sessionStorageUtils } from "../../../../utility/utility";
import { AppConstants } from "../../../../constants/constant";

interface RadioSectionProps {
  field: Field;
  error: string | undefined | null;
  handleFunction: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors?: Errors;
}

const RadioSection: React.FC<RadioSectionProps> = ({
  field,
  error,
  handleFunction,
  errors,
}) => {
  const { formValues, setFormValues } = useFormContext();

  useEffect(() => {
    const leadFlowFromFinancingPage = sessionStorageUtils.getItem(
      "leadFlowFromFinancingPage",
    );

    if (field.id === AppConstants.FINANCING_INTEREST) {
      const isFromFinancingPage = leadFlowFromFinancingPage
        ? JSON.parse(leadFlowFromFinancingPage)
        : false;
      const optionId = isFromFinancingPage ? "yes" : "no";
      setFormValues((prevState) => ({
        ...prevState,
        [field.id]: optionId,
      }));
      return;
    }

    const serviceTypeFromSession = sessionStorageUtils.getItem("serviceType");

    if (
      field.defaultSelected &&
      field.options?.length > 0 &&
      !formValues[field.id]
    ) {
      const defaultValue =
        serviceTypeFromSession === "commercial"
          ? field.options?.find(
              (option) => option.id?.toLowerCase() === serviceTypeFromSession,
            )?.id
          : field.options[0]?.id;
      setFormValues((prevState) => ({
        ...prevState,
        servicetype: defaultValue,
      }));
    }
  }, [field.defaultSelected, field.id]);

  return (
    <FormControl component="div" className={`${field.id} full-width`} fullWidth>
      <div className="label-basic" data-testid={field?.id}>
        {field.label}
        {field.required && <sup>*</sup>}
      </div>
      <RadioGroup
        name={field.id}
        value={formValues[field.id] || ""}
        onChange={handleFunction}
        className={useErrorClassClassifier({
          error: !!error?.length,
          errorClassToApply: "input-label-wrap-highlight",
          defaultClass: "input-label-wrap",
        })}
        row={true}
        data-testid={field.id}
      >
        {field?.options?.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option.id}
            control={
              <Radio
                data-testid={option.id}
                inputProps={
                  {
                    "data-serviceid": option.value || "",
                  } as React.InputHTMLAttributes<HTMLInputElement>
                }
              />
            }
            label={
              <Typography id={option.id + "-text"} style={{ fontSize: "1rem" }}>
                {option.label}
              </Typography>
            }
          />
        ))}
      </RadioGroup>
      {(error || errors?.[field.id]) && (
        <div className="error-message">{error || errors?.[field.id]}</div>
      )}
    </FormControl>
  );
};

export default RadioSection;
